import React from 'react';
import styled from 'styled-components';
import isEmpty from 'lodash/isEmpty';

import Col from 'components/ui/Col';
import Row from 'components/ui/Row';

import { ServiceAndUtilityAnswerInput } from './ServiceAndUtilityAnswerInput';
import { ServiceAndUtilityAnswerRadioButton } from './ServiceAndUtilityAnswerRadioButton';

import { leaseCreatorColors } from 'helpers/ColorHelper';
import { responsive } from 'helpers/StyleHelper';
import { media, sizes } from 'helpers/MediaHelper';

const StyledRow = styled(Row)`
  width: 100%;
  margin-bottom: ${(props) => props.mb || '21px'};
  margin-top: ${(props) => props.mt || '0px'};
  display: flex;
  align-items: center;
  ${media.mobile`
    flex-wrap: wrap;
    row-gap: 8px;
  `};
`;

const StyledLabel = styled.div`
  font-size: 16px;
  line-height: 24px;
  color: ${leaseCreatorColors.HEADER};
  font-weight: 400;
  ${media.mobile`
    font-weight: 600;
  `};
`;

const ServiceAndUtilityQuestion = ({
  values,
  setFieldValue,
  parentQuestion,
  parentIndex,
  serviceOrUtility,
}) => {
  const isMobile = window.matchMedia(`(max-width: ${sizes.mobile}px)`).matches;
  const labelSize = isMobile ? responsive.text.mobile : responsive.text.desktop;

  if (parentQuestion.answer_type === 'checkbox' || parentQuestion.answer_type === 'radio') {
    const selectedParentAnswerIndex = parentQuestion.answers.findIndex((ans) => ans.selected);
    const selectedParentAnswer = parentQuestion.answers[selectedParentAnswerIndex];
    const showConditional =
      selectedParentAnswer.selected && !isEmpty(selectedParentAnswer.conditional_questions);

    return (
      <React.Fragment>
        <StyledRow gutter={16}>
          <Col md={12}>
            <StyledLabel labelSize={labelSize}>{parentQuestion.question_name}</StyledLabel>
          </Col>
          <Col md={12}>
            <ServiceAndUtilityAnswerRadioButton
              values={values}
              setFieldValue={setFieldValue}
              question={parentQuestion}
              isChild={false}
              selectedParentAnswer={selectedParentAnswer}
              parentIndex={parentIndex}
              serviceOrUtility={serviceOrUtility}
              isMobile={isMobile}
            />
          </Col>
        </StyledRow>
        {showConditional &&
          selectedParentAnswer.conditional_questions.map((conditionalQuestion, index) => {
            const selectedConditionalAnswer = conditionalQuestion.conditional_answers.find(
              (ans) => ans.selected
            );
            return (
              <StyledRow gutter={16} key={index}>
                <Col md={12}>
                  <StyledLabel labelSize={labelSize}>{conditionalQuestion.name}</StyledLabel>
                </Col>
                <Col md={12}>
                  {conditionalQuestion.type === 'checkbox' ||
                  conditionalQuestion.type === 'radio' ? (
                    <ServiceAndUtilityAnswerRadioButton
                      setFieldValue={setFieldValue}
                      question={conditionalQuestion}
                      isChild={true}
                      selectedParentAnswer={selectedParentAnswer}
                      selectedConditionalAnswer={selectedConditionalAnswer}
                      parentIndex={parentIndex}
                      selectedParentAnswerIndex={selectedParentAnswerIndex}
                      index={index}
                      serviceOrUtility={serviceOrUtility}
                      isMobile={isMobile}
                    />
                  ) : (
                    // type is 'text' type at child level
                    <ServiceAndUtilityAnswerInput
                      setFieldValue={setFieldValue}
                      question={conditionalQuestion}
                      isChild={true}
                      parentIndex={parentIndex}
                      selectedParentAnswerIndex={selectedParentAnswerIndex}
                      index={index}
                      serviceOrUtility={serviceOrUtility}
                      isMobile={isMobile}
                    />
                  )}
                </Col>
              </StyledRow>
            );
          })}
      </React.Fragment>
    );
  } else {
    // type is 'text' type at parent level
    return (
      <StyledRow gutter={16}>
        <Col md={12}>
          <StyledLabel labelSize={labelSize}>{parentQuestion.question_name}</StyledLabel>
        </Col>
        <Col md={12}>
          <ServiceAndUtilityAnswerInput
            setFieldValue={setFieldValue}
            question={parentQuestion}
            isChild={false}
            parentIndex={parentIndex}
            serviceOrUtility={serviceOrUtility}
            isMobile={isMobile}
          />
        </Col>
      </StyledRow>
    );
  }
};

export { ServiceAndUtilityQuestion };
